import { FC, useEffect, useMemo } from "react";
import { observer } from "mobx-react";

import PieChartCard from "./PieChartCard";
import { useObservabilityStore } from "../../../../hooks/useObservabilityStore";

const formatCount = (value: number): string => value.toLocaleString();

const CasesByPayerPie: FC = observer(() => {
  const { isCasesBreakdownLoading, casesBreakdown, loadCasesBreakdown } =
    useObservabilityStore();

  useEffect(() => {
    loadCasesBreakdown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const slices = useMemo(
    () =>
      (casesBreakdown?.by_payer ?? []).map((row) => ({
        name: row.payer,
        value: row.cases,
      })),
    [casesBreakdown?.by_payer],
  );

  return (
    <PieChartCard
      title="Cases by Payer"
      slices={slices}
      formatValue={formatCount}
      csvFilename="cases-by-payer"
      csvValueHeader="Cases"
      emptyMessage="No payer data available"
      isLoading={isCasesBreakdownLoading}
      csvSelectedOnly
    />
  );
});

export default CasesByPayerPie;
